import { API } from '@/models/api';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserService {
  private http = inject(HttpClient);

  getDashboard(): Observable<any> {
    return this.http.get(API.User.Dashboard.url);
  }
}
